import { audienceMemberSchema } from "@redotech/redo-model/marketing/audience";
import { SortDirection } from "@redotech/redo-model/tables/table";
import * as z from "zod/v4";

export const getAudience = {
  name: "getAudience" as const,
  input: z.object({
    search: z.string().optional(),
    sort: z
      .object({ key: z.string(), direction: z.enum(SortDirection) })
      .optional(),
    pageContinue: z.string().optional(),
    pageSize: z.number(),
  }),
  output: z.object({
    data: z.array(audienceMemberSchema),
    pageNext: z.string().nullable(),
  }),
};
